// ui/src/components/PushBadgeSync.tsx
import React, { useEffect } from 'react';
import { store } from '../store';
import { localApi } from '../store/api/localApi';

// Renders nothing. Bridges service-worker push events to RTK Query cache
// invalidation: when the SW posts NOTIFICATION_RECEIVED (on a Web Push), refresh
// the unread-count badges AND any open inbox list so a new message appears
// immediately, without a polling timer. Forms have no push, so the FormInvitation
// tag is intentionally not invalidated here.
const PushBadgeSync: React.FC = () => {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const onMessage = (e: MessageEvent) => {
      if (e.data?.type === 'NOTIFICATION_RECEIVED') {
        store.dispatch(
          localApi.util.invalidateTags([
            'MessageUnreadCount',
            'ObservationUnreadCount',
            'MessageDelivery',
            'ObservationDelivery',
          ])
        );
      }
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, []);

  return null;
};

export default PushBadgeSync;
